import React from "react";
import { Badge } from "@mui/material";
import {
  FilterPanelTrigger,
  GridFilterListIcon,
} from "@mui/x-data-grid-premium";
import { TableToolbarButton } from "./TableToolbarButton";

export default function ToolbarFilterButton() {
  return (
    <FilterPanelTrigger
      render={(props, state) => (
        <TableToolbarButton
          onClick={props.onClick}
          startIcon={
            <Badge
              badgeContent={state.filterCount}
              color="primary"
              variant="dot"
            >
              <GridFilterListIcon />
            </Badge>
          }
        >
          Filters
        </TableToolbarButton>
      )}
    />
  );
}
